import { AuctionHouse, Curated, MoneyCircle } from '@js/web/components/icons';

export const marketplaceAboutContent = {
  top: {
    title: ['About Fanatics Collect', 'Marketplace'],
    body: [
      'Fanatics Collect, a global leader in trading cards and related collectibles, provides daily access to auctions and Buy Now marketplaces. Using innovative bidding technology, third-party auction security, high-resolution images, and a sales history tool, Fanatics Collect empowers clients to make informed investment decisions.'
    ],
    textSide: 'left',
    id: 'about',
    backgroundColor: 'white',
    imageUrlDesktop: jsConfig.links.imagesUrl + 'about-marketplace-sweater-desktop.png',
    imageUrlMobile: jsConfig.links.imagesUrl + 'about-marketplace-sweater-mobile.png',
    titleType: 'h1',
    overflowImage: false,
    noAssetBackground: true,
    containImage: true
  },
  main: [
    {
      title: ['Our Story'],
      body: [
        '<p class="mb-4">When Brent Huigens was a child, he developed a passion for trading cards, especially vintage baseball cards. He has fond memories of his father taking him to buy packs and the thrill of flipping through the cards as he opened them. His favorite player was Christy Mathewson, an inaugural member of the Hall of Fame. As he grew up, his passion for card collecting grew. He began helping friends sell their cards. One day, Brent realized that his card collecting interest could become much more than a hobby.</p>',
        '<p class="mb-4">In 1999, Brent began investing in trading cards and developed a vision to build a marketplace that offered clients liquidity and storage. Brent imagined a business that would empower buyers and sellers to exchange cards in a marketplace and safely store them. Using his background as an engineer and entrepreneur, Brent launched Pre-War Card Collector Auctions in 2008 with two employees. He named the company after his passion for vintage cards. Originally located in Oakland, California, the team opened its headquarters in Tigard, Oregon in 2014. Fanatics Collect currently hosts the largest trading card marketplace in the world and serves thousands of clients from across the globe.</p>',
        '<p class="mb-0">Future about Fanatics Collect:</p>',
        '<p class="mb-4">Fanatics Collect believes that trading cards and related items should mature into the world\'s premier tangible asset class. Fanatics Collect will continue to innovate and respond to clients\' needs to help the industry reach its full potential.</p>',
      ],
      bodyIsHTML: true,
      textSide: 'right',
      id: 'ourStory',
      backgroundColor: 'gray',
      imageUrlDesktop: jsConfig.links.imagesUrl + 'about-marketplace-vault-desktop.png',
      imageUrlMobile: jsConfig.links.imagesUrl + 'about-marketplace-vault-mobile.png',
      overflowImage: false,
      noAssetBackground: true,
      containImage: true
    },
    {
      title: ['Eye Appeal Matters'],
      body: [
        'Fanatics Collect assesses the eye appeal of every vintage card from 1986 or prior with a market value over $250. Cards that earn an eye appeal sticker typically sell for higher prices in the Fanatics Collect.'
      ],
      textSide: 'left',
      id: 'eyeAppeal',
      backgroundColor: 'white',
      darkButtonLink: jsConfig.links.eyeAppealUrl,
      darkButtonText: 'Learn More',
      imageUrlDesktop: jsConfig.links.imagesUrl + 'about-marketplace-eye-appeal-desktop.png',
      imageUrlMobile: jsConfig.links.imagesUrl + 'about-marketplace-eye-appeal-mobile.png',
      overflowImage: false,
      noAssetBackground: true,
      containImage: true
    },
    {
      title: ['Marketplace Advances'],
      body: [
        'Fanatics Capital provides marketplace advances to clients seeking faster liquidity on items up for auction.'
      ],
      textSide: 'right',
      id: 'loans',
      backgroundColor: 'gray',
      // darkButtonEmit: 'capitalModal',
      // darkButtonText: 'Learn More',
      imageUrlDesktop: jsConfig.links.imagesUrl + 'about-marketplace-money-desktop.png',
      imageUrlMobile: jsConfig.links.imagesUrl + 'about-marketplace-money-mobile.png',
      hasBorderTop: false,
      overflowImage: false,
      noAssetBackground: true,
      containImage: true,
    },
    {
      title: ['Sell With Us'],
      body: [
        'Clients sell with Fanatics Collect because the platform attracts thousands of buyers. Buyers prefer to use Fanatics Collect versus other auction sites because Fanatics Collect uses a third-party technology company to ensure bidding integrity, provides high-resolution images of items that prevent buyers’ remorse, accurate titling, a wide selection from every genre, a sales history tool, easy checkout, outstanding customer service, and fast and safe shipping. Fanatics Collect also registers users and permanently bans buyers who do not pay for purchases to ensure sellers receive payment.'
      ],
      textSide: 'left',
      id: 'sell',
      backgroundColor: 'white',
      darkButtonLink: jsConfig.hasAuth ? jsConfig.links.submitUrl : jsConfig.links.registerUrl,
      darkButtonText: jsConfig.hasAuth ? 'Sell Now' : 'Register To Submit',
      imageUrlDesktop: jsConfig.links.imagesUrl + 'about-marketplace-sell-desktop.png',
      imageUrlMobile: jsConfig.links.imagesUrl + 'about-marketplace-sell-mobile.png',
      hasBorderTop: false,
      overflowImage: false,
      noAssetBackground: true,
      containImage: true,
    },
  ],
  eyeAppealTop: {
    title: ['The Fanatics Collect Eye Appeal Rating:', 'An Industry First'],
    body: [
      'Clients frequently use the eye appeal of a card to determine its market value. Factors such as surface color and centering relative to their peers of the same grade weigh heavily in these assessments. To assist investors with this process, Fanatics Collect assesses cards for their eye appeal and awards stickers to cards that present eye appeal that ranks in the top 30% in comparison to their peers of the same grade. Cards that receive the Fanatics Collect eye appeal designation typically sell for higher prices given their ranking with the grade.'
    ],
    textSide: 'left',
    backgroundColor: 'white',
    imageUrlDesktop: jsConfig.links.imagesUrl + 'about-marketplace-eye-appeal-desktop.png',
    imageUrlMobile: jsConfig.links.imagesUrl + 'about-marketplace-eye-appeal-mobile.png',
    titleType: 'h1',
    overflowImage: false,
    noAssetBackground: true,
    containImage: true
  },
  eyeAppealMain: [
    {
      title: ['ABOVE AVERAGE (PWCC-A)', 'TOP 30%'],
      body: [
        '<p class="mb-0">ABOVE AVERAGE eye appeal to the professional grade.</p>',
        '<p class="mb-4">In the opinion of Fanatics Collect, LLC, the offered vintage trading card - issued prior to 1987 and possessing market value over $250 - has eye appeal and overall presentation above what is average to the assigned professional grade. On average, cards which receive our Above Average designation possess qualities inherent to approximately the top 70-85% of all examples of this specific trading card, assessed at this specific professional grade level.</p>',
        '<p class="mb-4">No venue handles more investment caliber trading cards than Fanatics Collect, providing our staff the unique opportunity to assess the eye appeal of this particular trading card relative to other examples we have brokered. Fanatics Collect is not a professional grading company and this certification does not assert that this trading card is guaranteed a higher technical assessment from a 3rd party authenticator. Rather, the certification comments only on the relative appearance of the respective trading card and does not speak to or qualify the assigned technical grade.</p>'
      ],
      textSide: 'right',
      backgroundColor: 'white',
      imageUrlDesktop: jsConfig.links.imagesUrl + 'about-marketplace-eye-a-desktop.png',
      imageUrlMobile: jsConfig.links.imagesUrl + 'about-marketplace-eye-a-mobile.png',
      overflowImage: false,
      noAssetBackground: true,
      containImage: true,
      bodyIsHTML: true
    },
    {
      title: ['EXCEPTIONAL (PWCC-E)', 'TOP 15%'],
      body: [
        '<p class="mb-0">EXCEPTIONAL eye appeal to the professional grade.</p>',
        '<p class="mb-4">In the opinion of Fanatics Collect, LLC, the offered vintage trading card - issued prior to 1987 and possessing market value over $250 - has eye appeal and overall presentation that is exceptional for the assigned professional grade. On average,cards which receive our Exceptional designation possess qualities inherent to approximately the top 85-95% of all examples of this specific trading card, assessed at this specific professional grade level.</p>',
        '<p class="mb-4">No venue handles more investment caliber trading cards than Fanatics Collect, providing our staff the unique opportunity to assess the eye appeal of this particular trading card relative to other examples we have brokered. Fanatics Collect is not a professional grading company and this certification does not assert that this trading card is guaranteed a higher technical assessment from a 3rd party authenticator. Rather, the certification comments only on the relative appearance of the respective trading card and does not speak to or qualify the assigned technical grade.</p>'
      ],
      textSide: 'left',
      backgroundColor: 'gray',
      imageUrlDesktop: jsConfig.links.imagesUrl + 'about-marketplace-eye-e-desktop.png',
      imageUrlMobile: jsConfig.links.imagesUrl + 'about-marketplace-eye-e-mobile.png',
      overflowImage: false,
      noAssetBackground: true,
      containImage: true,
      bodyIsHTML: true
    },
    {
      title: ['SUPERIOR (PWCC-S)', 'TOP 5%'],
      body: [
        '<p class="mb-0">SUPERIOR eye appeal to the professional grade.</p>',
        '<p class="mb-4">In the opinion of Fanatics Collect, LLC, the offered vintage trading card - issued prior to 1987 and possessing market value over $250 - has eye appeal and overall presentation superior to the assigned professional grade. On average, cards which receive our Superior designation possess qualities inherent to approximately the top 5% or less of all examples of this specific trading card, assessed at this specific professional grade level.</p>',
        '<p class="mb-4">No venue handles more investment caliber trading cards than Fanatics Collect, providing our staff the unique opportunity to assess the eye appeal of this particular trading card relative to other examples we have brokered. Fanatics Collect is not a professional grading company and this certification does not assert that this trading card is guaranteed a higher technical assessment from á 3rd party authenticator. Rather, the certification comments only on the relative appearance of the respective trading card and does not speak to or qualify the assigned technical grade.</p>'
      ],
      textSide: 'right',
      backgroundColor: 'white',
      imageUrlDesktop: jsConfig.links.imagesUrl + 'about-marketplace-eye-s-desktop.png',
      imageUrlMobile: jsConfig.links.imagesUrl + 'about-marketplace-eye-s-mobile.png',
      overflowImage: false,
      noAssetBackground: true,
      containImage: true,
      bodyIsHTML: true
    }
  ],
  capitalTop: {
    title: ['Fanatics Capital'],
    body: [
      'Fanatics Capital helps clients leverage their assets to better monetize trading card investing.'
    ],
    textSide: 'left',
    backgroundColor: 'white',
    imageUrlDesktop: jsConfig.links.imagesUrl + 'about-marketplace-money-desktop.png',
    imageUrlMobile: jsConfig.links.imagesUrl + 'about-marketplace-money-mobile.png',
    titleType: 'h1',
    overflowImage: false,
    noAssetBackground: true,
    containImage: true
  },
  capitalMain: [
    {
      title: ['Auction Marketplace Advances'],
      body: [
        'Clients selling authenticated trading cards through the Fanatics Collect Weekly Auction or Monthly Premier Auction can request a marketplace advance for up to 50% of the conservative market value of their submission. As a Fanatics Collect client, cash advances allow you to increase your purchasing power, so you can build your portfolio.'
      ],
      textSide: 'right',
      backgroundColor: 'white',
      darkButtonLink: jsConfig.links.capitalUrl,
      darkButtonText: 'Request',
      imageUrlDesktop: jsConfig.links.imagesUrl + 'about-marketplace-cash-advance-desktop.png',
      imageUrlMobile: jsConfig.links.imagesUrl + 'about-marketplace-cash-advance-mobile.png',
      overflowImage: false,
      noAssetBackground: true,
      containImage: true
    }
  ]
};

export const marketplaceTripleIconMessages = [
  {
    icon: AuctionHouse,
    iconColor: '#FFF',
    iconBgColor: '#282828',
    title: ['Marketplaces'],
    message: 'The Fanatics Collect Weekly Sunday Auction, Monthly Premier Auction, and Buy Now Marketplace provide clients an opportunity to buy and sell the industry\'s most sought-after items every day of the year.'
  },
  {
    icon: Curated,
    iconColor: '#FFF',
    iconBgColor: '#282828',
    title: ['Vault'],
    message: 'The original and most sophisticated trading card archival service in the world. Built from scratch and designed to provide investors the storage and liquidity options they deserve.'
  },
  {
    icon: MoneyCircle,
    iconColor: '#FFF',
    iconBgColor: '#282828',
    title: ['Capital'],
    message: 'Fanatics Capital provides marketplace advances to clients seeking faster liquidity on items up for auction.'
  },
];
